// extracted by mini-css-extract-plugin
module.exports = {"previewWrapper":"PromptPreviewModal_previewWrapper__1tlim"};